module.exports = __webpack_public_path__ + "static/media/img_13.8306a6d2.JPG";